import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import SignPage from "./pages/SignPage";
import VerifyPage from "./pages/VerifyPage";
import IntegrationPage from "./pages/IntegrationPage";
import PopupPage from "./pages/PopupPage";
import AgentePage from "./pages/AgentePage";
import BatchSignPage from "./pages/BatchSignPage";
import VisibleSignPage from "./pages/VisibleSignPage";

function MainLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-[#FAF9F6]">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sign" element={<SignPage />} />
          <Route path="/sign/visible" element={<VisibleSignPage />} />
          <Route path="/sign/batch" element={<BatchSignPage />} />
          <Route path="/sign/:docId" element={<SignPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/integrar" element={<IntegrationPage />} />
          <Route path="/agente" element={<AgentePage />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/popup" element={<PopupPage />} />
          <Route path="/*" element={<MainLayout />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
